import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { MergeTiersAndPoints } from './MergeTiersAndPoints';
import { NavButtons } from '../NavButtons/NavButtons';
import TopicTracker from '../../../../tracking/TopicTracker';

export const MergeTiersAndPointsContainer = ({
  onConfirmButtonClick,
  onError
}) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    TopicTracker.show('email', 'tiers-and-points');
  }, []);

  const handleConfirmButtonClick = () => {
    setIsLoading(true);
    TopicTracker.click('email', 'tiers-and-points-ok');
    onConfirmButtonClick();
    setIsLoading(false);
  };

  const handleCancelClickButton = () => {
    TopicTracker.click('email', 'tiers-and-points-cancel');
  };

  return (
    <Fragment>
      <MergeTiersAndPoints/>
      <NavButtons
        isLoading={isLoading}
        isDisabled={false}
        isCancelEnabled
        onClick={handleConfirmButtonClick}
        onClickCancel={handleCancelClickButton}
      />
    </Fragment>);
};


MergeTiersAndPointsContainer.propTypes = {
  onConfirmButtonClick: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};
